// extracted by mini-css-extract-plugin
export default {"academicStaff":"AcademicStaff_academicStaff__jucHd","professorsList":"AcademicStaff_professorsList__1toIW"};